/**
 * @file
 * Behaviors for the search box
 */
/* eslint-disable max-len */

(function (Drupal) {
  Drupal.behaviors.mobileSearchTransform = {
    attach: function (context) {
      once('searchBox', '.utility-nav #search-block-form', context).forEach(
        function(form) {
          // Debounce function
          function debounce(func, delay) {
            let timer;
            return function () {
              const context = this;
              const args = arguments;
              clearTimeout(timer);
              timer = setTimeout(() => func.apply(context, args), delay);
            };
          }

          function updateMarkup() {
            const windowWidth = window.innerWidth;
            const container = document.getElementById('utility-nav--container');
            const formActions = document.querySelector('.utility-nav #search-block-form .form-actions');
            const submitButton = document.querySelector('button.leh-search--btn');
            const toggleButton = document.createElement('div');
            toggleButton.className = 'leh-search--btn btn btn-icon';
            toggleButton.id = 'leh-toggle-btn';
            toggleButton.setAttribute('role', 'button');
            toggleButton.innerHTML = `
              <span class="material-symbols-outlined leh-search--icon icon-search">search</span>
              <span class="material-symbols-outlined leh-search--icon icon-close">close</span>
            `;
            if (windowWidth <= 991) {
              form.classList.add('mobile');
              form.classList.add('search-mobile');
              if (formActions.contains(submitButton)) {
                formActions.replaceChild(toggleButton, submitButton);
              }
              toggleButton.onclick = function () {
                container.classList.toggle('active');
              };
            } else {
              form.classList.remove('mobile');
              form.classList.remove('search-mobile');
              if (formActions.contains(toggleButton)) {
                formActions.replaceChild(submitButton, toggleButton);
              }
            }
          }

          updateMarkup();

          window.addEventListener('resize', debounce(() => {
            updateMarkup();
          }, 150));
        }
      );
    }
  };
})(Drupal);
